/******************************************************************************
 *
 * WorkTimelineCard
 *
 * Displays runtime history of Work.
 *
 * Future
 *
 * • Assignment History
 * • Checklist Completion
 * • Work Item Completion
 * • Approval History
 * • Document Upload
 * * Comments
 *
 ******************************************************************************/

import React from "react";

export default function WorkTimelineCard({

    timeline = []

}) {

    return (

        <div className="card border-0 shadow-sm h-100">

            <div className="card-header bg-white">

                <div className="d-flex justify-content-between align-items-center">

                    <h5 className="mb-0">

                        🕒 Timeline

                    </h5>

                    <span className="badge bg-secondary">

                        {timeline.length}

                    </span>

                </div>

            </div>

            <div
                className="card-body"
                style={{
                    maxHeight: 450,
                    overflowY: "auto"
                }}
            >

                {

                    timeline.length === 0

                    ?

                    <div className="text-center text-muted py-5">

                        No activity available.

                    </div>

                    :

                    timeline.map(event => (

                        <div
                            key={event.id}
                            className="d-flex mb-4"
                        >

                            <div
                                className="me-3"
                                style={{
                                    width: 16
                                }}
                            >

                                <div
                                    className="bg-primary rounded-circle"
                                    style={{
                                        width: 12,
                                        height: 12,
                                        marginTop: 5
                                    }}
                                />

                            </div>

                            <div className="flex-grow-1">

                                <div className="fw-semibold">

                                    {event.title}

                                </div>

                                <div className="small text-muted">

                                    {event.description}

                                </div>

                                <div className="small text-secondary mt-1">

                                    {event.created_by}

                                    {" • "}

                                    {event.created_at}

                                </div>

                            </div>

                        </div>

                    ))

                }

            </div>

        </div>

    );

}